(function () {
  'use strict';

  var STORAGE_KEY = 'svr_countdown_target';
  var WINDOW_MS = 23 * 60 * 60 * 1000 + 59 * 60 * 1000; // 23h59m

  function getOrSetTarget() {
    var now = Date.now();
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        var t = parseInt(stored, 10);
        if (!isNaN(t) && t > now) return t;
      }
      var target = now + WINDOW_MS;
      sessionStorage.setItem(STORAGE_KEY, String(target));
      return target;
    } catch (e) {
      // sessionStorage disabled or quota exceeded — fall back to in-memory target
      return now + WINDOW_MS;
    }
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function render(elements, target) {
    var diff = target - Date.now();
    if (diff <= 0) {
      // reset to a fresh window
      var newTarget = Date.now() + WINDOW_MS;
      try { sessionStorage.setItem(STORAGE_KEY, String(newTarget)); } catch (e) {}
      target = newTarget;
      diff = WINDOW_MS;
    }
    var hrs = Math.floor(diff / (1000 * 60 * 60));
    var min = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var sec = Math.floor((diff % (1000 * 60)) / 1000);
    elements.forEach(function (el) {
      var hEl = el.querySelector('[data-cd-hrs]');
      var mEl = el.querySelector('[data-cd-min]');
      var sEl = el.querySelector('[data-cd-sec]');
      if (hEl) hEl.textContent = pad(hrs);
      if (mEl) mEl.textContent = pad(min);
      if (sEl) sEl.textContent = pad(sec);
    });
    return target;
  }

  function init() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('.svr-countdown'));
    if (!elements.length) return;
    var target = getOrSetTarget();
    target = render(elements, target);
    setInterval(function () { target = render(elements, target); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();